import $ from 'jquery';

if($('#page-popup').length > 0) {
    $.magnificPopup.open({
        items: {
            src: '#page-popup'
        },
        type: 'inline',
    });
}
